import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';





import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';

function createData(
    id,
    title,
    code, type, dimensions, price, exhibitor, status,


) {
    return { id, title, code, type, dimensions, price, exhibitor, status };
}



const rows = [
    createData(1, "ssss ipsum dolor sit amet, ", '01', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(2, "ssss ipsum dolor sit amet, ", '09', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(3, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(4, "ssss ipsum dolor sit amet, ", '08', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(5, "ssss ipsum dolor sit amet, ", '05', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(6, "ssss ipsum dolor sit amet, ", '09', 'squir', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(7, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(8, "ssss ipsum dolor sit amet, ", '11', 'circle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(9, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(10, "ssss ipsum dolor sit amet, ", '51', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(11, "ssss ipsum dolor sit amet, ", '21', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(12, "ssss ipsum dolor sit amet, ", '31', 'Round', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(13, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),


].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const ManageWorkShop = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');
    const [customFieldList, setCustomFieldList] = React.useState([]);
    const [permissions, setrPermissions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [workshop, setworkshop] = useState([]);
    const [copiedMessage, setCopiedMessage] = useState('');

    useEffect(() => {
        axios.get(`api/workshop-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.workshop;
                setworkshop(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);


    React.useEffect(() => {
        return () => {
            setAllData(rows)
        };
    }, []);
    const eventid = localStorage.getItem('eventid')
    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);

    React.useEffect(() => {
        axios.get(`api/list-customfield?id=${eventid}`).then(res => {

            if (res.status === 200) {
                const FieldList = res.data.customFieldList;
                setCustomFieldList(FieldList)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);


    const WorkShopDelete = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."
        axios.get(`api/workshop-status/${id}`).then(res => {
            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();
            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });
    }
    
    const handleCopyUrl = (id) => {
        const domain = window.location.origin; // Get the current domain
        const url = `${domain}/workshops/#/workshop/attendance/${id}`;

        navigator.clipboard.writeText(url)
            .then(() => {
                // URL copied successfully
                const message = 'URL copied!';
                setCopiedMessage(message);
                console.log('URL copied:', url);
                // Hide the message after some time (e.g., 3 seconds)
                setTimeout(() => {
                    setCopiedMessage('');
                }, 3000);
            })
            .catch((error) => {
                console.error('Error copying URL:', error);
                // Handle errors if any
            });
    };



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const filteredRows = rows.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const [searchTerm, setSearchTerm] = useState('');
    const filteredPosts = workshop.filter((row) =>
        //(row.phone && row.phone.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.name && row.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.email && row.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.role && row.role.toLowerCase().includes(searchTerm.toLowerCase()))
        // Add more fields with null checks as needed
    );
    const totalRecords = workshop.length;
    const filteredRecordsCount = filteredPosts.length;
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,

    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                <Card sx={{ width: '82vw', float: 'center' }} >
                    <CardContent >
                        {/* <Typography component="h1" variant="h5">
                            List Of CustomField (Active)
                        </Typography> */}



                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography component="h1" variant="h5">
                                    Manage WorkShop
                                </Typography>
                                Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
                                <Grid item xs={8} >
                                    <TextField
                                        fullWidth
                                        label="Filter By: Name"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Grid>

                            </div>
                            {
                                permissions['p_workshop-manage-workshop-add'] === true ?

                                    <Button sx={{
                                        float: 'right',
                                        marginTop: '2%',
                                        backgroundColor: backGroundButtonByEvent,
                                        ":hover": {
                                            color: "white"
                                        }
                                    }}
                                        color='success'
                                        size='small'
                                        variant='contained'
                                        component={Link}
                                        to="/admin/workshop/add">
                                        Add New
                                    </Button> : ""}
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell > #</TableCell>
                                            <TableCell align="left">WorkShop Name</TableCell>
                                            <TableCell align="left">WorkShop Code</TableCell>
                                            <TableCell align="left">workshop category</TableCell>
                                            <TableCell align="left">workshop Day</TableCell>
                                            <TableCell align="left">workshop Date</TableCell>
                                            <TableCell align="left"> workshop Start Time</TableCell>
                                            <TableCell align="left"> workshop End Time</TableCell>
                                            <TableCell align="left">Seats</TableCell>
                                            <TableCell align="left">Price</TableCell>
                                            <TableCell align="left">Discount Price</TableCell>
                                            <TableCell align="left">Action</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    {copiedMessage && (
                                        <div style={{ position: 'fixed', right: '10px', background: 'white', color: 'green', padding: '10px', boxShadow: '0px 0px 5px rgba(0,0,0,0.3)', borderRadius: '5px' }}>
                                            {copiedMessage}
                                        </div>
                                    )}
                                    <TableBody>
                                        {workshop && workshop.slice(startIndex, endIndex).map((row, index) => (
                                            <TableRow key={index}>
                                                <>
                                                    <TableCell key={row.id}>{row.id}</TableCell>
                                                    <TableCell >{row.workshop_name}</TableCell>
                                                    <TableCell >{row.workshop_code}</TableCell>
                                                    <TableCell>{row.workshopcategory ? row.workshopcategory.workshop_category_title : 'N/A'}</TableCell>
                                                    <TableCell >{row.workshop_date}</TableCell>
                                                    <TableCell >{row.workshop_url}</TableCell>
                                                    <TableCell >{row.workshop_start_time}</TableCell>
                                                    <TableCell >{row.workshop_end_time}</TableCell>
                                                    <TableCell >{row.workshop_no_ofseats}</TableCell>
                                                    <TableCell >{row.workshop_amount}</TableCell>
                                                    <TableCell>{row.workshop_discount_amount ? row.workshop_discount_amount : "0"}</TableCell>
                                                    <TableCell >


                                                        {
                                                            permissions['p_workshop-manage-workshop-edit'] === true ?

                                                                <Button sx={{
                                                                    margin: 1,

                                                                    ":hover": {
                                                                        color: "white"
                                                                    },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    variant='contained'
                                                                    // onClick={(e) => handleClickEditRecord(row.id)}
                                                                    component={Link}
                                                                    to={`/admin/workshop/edit/${row.id}`}>

                                                                    <EditNoteIcon />
                                                                </Button> : ""}


                                                        {
                                                            permissions['p_workshop-manage-workshop-delete'] === true ?
                                                                <Button sx={{
                                                                    ":hover": {
                                                                        color: "white"
                                                                    },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    onClick={(e) => WorkShopDelete(e, row.id)}>

                                                                    <DeleteIcon />
                                                                </Button> : ""}
                                                        {
                                                            permissions['p_workshop-attendance-url'] === true ?

                                                                <Button
                                                                    sx={{
                                                                        margin: 1,
                                                                        ":hover": {
                                                                            color: "white"
                                                                        },
                                                                        backgroundColor: backGroundButtonByEvent,
                                                                    }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    onClick={() => handleCopyUrl(row.id)} // Call handleCopyUrl with the workshop ID
                                                                >
                                                                    Attendance url {/* Icon for copying */}
                                                                </Button> : ""}


                                                    </TableCell>

                                                </>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000,]}
                                    component="div"
                                    count={filteredRows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>

                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default ManageWorkShop;
